import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { set } from 'lodash';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import memoize from 'memoize-one';
import { TYPES } from 'sarsaparilla';
import Alert from '../../../../ui-lottery/src/components/Alert';
import { STATE_UNLOADED, STATE_READY } from '../../../../ui-lottery/src/utils/async_utils';
import { fetchOrganizations } from '../../actions/organization';
import { saveSearch } from '../../actions/search';
import Changelog from '../../components/Changelog/Changelog';
import { StewardSearchForm } from '../../components/StewardSearchForm/StewardSearchForm';
import { AssetProps } from '../../props/asset';
import { CurrentUserProps } from '../../props/currentUser';
import { OrganizationProps } from '../../props/organization';
import { SearchProps } from '../../props/search';
import { getState } from '../../reducers';
import { getAssets, getAssetCount } from '../../reducers/assets';
import { getCurrentUser } from '../../reducers/currentUser';
import { getOrganization, getOrganizations } from '../../reducers/organizations';
import { getSearch } from '../../reducers/search';
import { flattenOrg, flattenOrgs, orgsToOptions } from '../../utils/organization';
import { changelog } from './changelog';

import styles from './StewardEntryPage.scss';

const propTypes = {
  history: TYPES.HISTORY,
  currentUser: CurrentUserProps,
  searchQuery: SearchProps,
  assets: PropTypes.arrayOf(AssetProps),
  assetCount: PropTypes.number,
  organization: OrganizationProps,
  organizations: PropTypes.arrayOf(OrganizationProps),
  states: PropTypes.objectOf(PropTypes.number),
  fetchOrganizations: PropTypes.func.isRequired,
  saveSearch: PropTypes.func.isRequired
};

export class StewardEntryPage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      // eslint-disable-next-line react/no-unused-state
      facilityQuery: {
        assetTypes: ['facility'],
        limit: 10,
        term: '',
        org: ''
      },
      // eslint-disable-next-line react/no-unused-state
      recAreaQuery: {
        assetTypes: ['recarea'],
        limit: 10,
        term: '',
        org: ''
      }
    };

    this.doSearch = this.doSearch.bind(this);
    this.doInsert = this.doInsert.bind(this);

    this.setQuery = this.setQuery.bind(this);
  }

  componentDidMount() {
    if (this.props.states.organizations === STATE_UNLOADED) {
      this.props.fetchOrganizations();
    }
  }

  setQuery(path, value) {
    this.setState((prevState) => set(prevState, path, value));
  }

  getOrgOptions = memoize((organizationsState, currentUserState, currentUser, organization, organizations) => {
    if (organizationsState === STATE_READY && currentUserState === STATE_READY) {
      if (currentUser && currentUser.apiKey.orgId && organization) {
        return orgsToOptions(flattenOrg(organization));
      }
      if (organizations) {
        return orgsToOptions(flattenOrgs(organizations));
      }
    }

    return [];
  });

  doSearch(query) {
    const assetType = query.assetTypes[0];

    this.props.saveSearch(query)
      .then(() => this.props.history.push(`/data-steward/${assetType}/search`));
  }

  doInsert(query) {
    const assetType = query.assetTypes[0];

    this.props.history.push(`/data-steward/${assetType}/new`);
  }

  render() {
    const {
      states: {organizations: organizationsState, currentUser: currentUserState},
      currentUser,
      organization,
      organizations
    } = this.props;
    const orgOptions = this.getOrgOptions(organizationsState, currentUserState, currentUser, organization, organizations);
    return (
      <div className={styles['entry-page']}>
        <Alert alert={{
          id: '1',
          level: 'info',
          title: 'Reservable & Non-Reservable Records',
          message: `Both reservable and non-reservable records are available for viewing in the RIDB UI and API but you
          will only be able to edit non-reservable records here. To edit reservable records use the links provided that
          will open the Hub.`
        }} />
        <h1>Search</h1>
        <div className={styles['search-form']}>
          <StewardSearchForm
            id="recarea"
            name="Rec Area"
            orgOptions={orgOptions}
            onSearch={this.doSearch}
            onInsert={this.doInsert} />
          <StewardSearchForm
            id="facility"
            name="Facility"
            orgOptions={orgOptions}
            onSearch={this.doSearch}
            onInsert={this.doInsert} />
        </div>
        <p><strong>Changelog</strong></p>
        <Changelog changelog={changelog} />
      </div>
    );
  }
}

StewardEntryPage.propTypes = propTypes;

const mapStateToProps = (state) => ({
  currentUser: getCurrentUser(state),
  searchQuery: getSearch(state),
  assets: getAssets(state),
  assetCount: getAssetCount(state),
  organization: getOrganization(state, getCurrentUser(state).apiKey.orgId),
  organizations: getOrganizations(state),
  states: getState(state, 'organizations', 'currentUser')
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
  saveSearch,
  fetchOrganizations
}, dispatch);

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(StewardEntryPage));
